import { all, fork } from "redux-saga/effects";

import { listViewSaga } from "./listView/saga";
import { moveStopsSaga } from "./moveStops/saga";
import { routeDetailsSaga } from "./routeDetails/sagas";
import { upcomingViewSaga } from "./upcomingView/saga";

export function* routeSaga() {
  yield all([
    fork(listViewSaga),
    fork(moveStopsSaga),
    fork(routeDetailsSaga),
    fork(upcomingViewSaga),
  ]);
}
